module.exports = __webpack_public_path__ + "img/icon-shipping.bc1fe057.svg";